import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/feature/JsonLd";
import { useLocalizedMeta } from "@/hooks/useLocalizedMeta";
import { ORGANIZATION_SCHEMA, WEBSITE_SCHEMA } from "@/data/schema";
import Hero from "./components/Hero";
import WhatIs from "./components/WhatIs";
import CategorySection from "./components/CategorySection";
import ArticleSection from "./components/ArticleSection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  useLocalizedMeta();

  return (
    <>
      <JsonLd data={ORGANIZATION_SCHEMA} />
      <JsonLd data={WEBSITE_SCHEMA} />
      <Navbar />
      <main>
        <Hero />
        <WhatIs />
        <CategorySection />
        <ArticleSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}